import { render, staticRenderFns } from "./EditBranch.vue?vue&type=template&id=d78b0e4c&scoped=true&"
import script from "./EditBranch.vue?vue&type=script&lang=ts&"
export * from "./EditBranch.vue?vue&type=script&lang=ts&"
import style0 from "./EditBranch.vue?vue&type=style&index=0&id=d78b0e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78b0e4c",
  null
  
)

export default component.exports